export const GET_MEDICATIONS_LIST = 'prescriptions/GET_MEDICATIONS_LIST';
export const GET_PRESCRIPTIONS_LIST = 'prescriptions/GET_PRESCRIPTIONS_LIST';
export const GET_PATIENT_PRESCRIPTIONS = 'prescriptions/GET_PATIENT_PRESCRIPTIONS';
export const CREATE_PRESCRIPTION = 'prescriptions/CREATE_PRESCRIPTION';
export const EDIT_PRESCRIPTION = 'prescriptions/EDIT_PRESCRIPTION';
export const SEND_PRESCRIPTION_TO_PHARMACY = 'prescriptions/SEND_PRESCRIPTION_TO_PHARMACY';
export const DELETE_PRESCRIPTION = 'prescriptions/DELETE_PRESCRIPTION';


export function getMedicationsList(search) {
    return {
        type: GET_MEDICATIONS_LIST,
        httpRequest: {
            method: 'get',
            path: '/encounterPrescriptions/medications',
            params: {
                search,
            },
        },
    };
}

export function getPatientPrescriptions(patientId, {limit, offset, filter}) {
    return {
        type: GET_PATIENT_PRESCRIPTIONS,
        httpRequest: {
            method: 'get',
            path: `/encounterPrescriptions/list/all/${patientId}`,
            params: {
                offset,
                limit,
                status: filter.status,
            },
        },
        offset,
        limit,
    };
}

export function getPrescriptionsList(encounterId, {offset, limit}) {
    return {
        type: GET_PRESCRIPTIONS_LIST,
        httpRequest: {
            method: 'get',
            path: `/encounterPrescriptions/list/${encounterId}`,
            params: {
                offset,
                limit,
            },
        },
        offset,
        limit,
    };
}

export function createPrescription(encounterId, data) {
    return {
        type: CREATE_PRESCRIPTION,
        httpRequest: {
            method: 'post',
            path: `/encounterPrescriptions/${encounterId}`,
            data,
        },
    };
}

export function sendPrescriptionToPharmacy(prescriptionId) {
    return {
        type: SEND_PRESCRIPTION_TO_PHARMACY,
        httpRequest: {
            method: 'put',
            path: `/encounterPrescriptions/send/${prescriptionId}`,
        },
    };
}

export function editPrescription(prescriptionId, fields) {
    return {
        type: EDIT_PRESCRIPTION,
        httpRequest: {
            method: 'put',
            path: `/encounterPrescriptions/${prescriptionId}`,
            data: fields,
        },
        id: prescriptionId,
        fields,
    };
}

export function deletePrescriptions(prescriptionId) {
    return {
        type: DELETE_PRESCRIPTION,
        httpRequest: {
            method: 'del',
            path: `/encounterPrescriptions/${prescriptionId}`,
        },
        id: prescriptionId,
    };
}



// WEBPACK FOOTER //
// ./src/reducers/prescription/prescriptionActions.js